import axios from "axios";

export const apiUrl = import.meta.env.VITE_API_URL;
// Static bootstrap bearer token used by the ~400 existing API call sites
// (`${Config.apiToken}`) and by apiClient below. Per the Cooptex pattern,
// the Keycloak access token is used ONLY for the one-time login/bootstrap
// call in AuthProvider.signInWithKeycloak() -- it is not threaded into the
// existing application API calls, which keep using this static token and
// the existing per-user `token` localStorage value exactly as before.
export const apiToken = import.meta.env.VITE_API_URL_TOKEN;
export const erpApiUrl = import.meta.env.VITE_ERP_API_URL;
export const VITE_API_Chat_URl = import.meta.env.VITE_API_Chat_URl;
// Face service (FastAPI) host, e.g. https://devportalfapi.oasyscybernetics.in.
// Dev server: VITE_FACE_DEV_URL (e.g. http://localhost:8765, set in
// .env.dev.local) is called directly; unset = '' so face calls stay relative
// and go through the Vite '/api/face' proxy. Builds call VITE_FACE_API_URL.
export const FACE_API_URL = import.meta.env.DEV
  ? import.meta.env.VITE_FACE_DEV_URL || ''
  : import.meta.env.VITE_FACE_API_URL;
 
export const homeurl = `${window.location.origin}/portal/${import.meta.env.VITE_APP_HOME_URL}`;

export const portalUrl = import.meta.env.VITE_PORTAL_URL || homeurl;
export const academyUrl = import.meta.env.VITE_ACADEMY_URL;
 
/**
 * Central Axios client for entire app
 */
const apiClient = axios.create({
  baseURL: apiUrl,
  headers: {
    Authorization: `Bearer ${apiToken}`,
    "Content-Type": "application/json",
  },
});

export default apiClient;


